import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  footer: {
    background: 'linear-gradient(91deg, #E0E0E0 0.85%, #FFF 128.9%)',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '0px',
    position: 'relative',
    zIndex: 999999,
  },
  content: {
    width: '90%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '40px 0',
    '@media (max-width : 768px)': {
      flexDirection: 'column',
      gap: '20px',
    },
  },
  leftSec: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    '@media (max-width : 768px)': {
      alignItems: 'start',
      width: '100%',
    },
  },
  logo: {
    width: 200,
  },
  links: {
    display: 'flex',
    flexDirection: 'row',
    gap: '20px',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      gap: '10px',
      margin: '20px 0px',
    },
  },
  textContent: {
    color: '#8E8E8E',
    fontFamily: 'Onest',
    fontSize: '12px',
    fontWeight: 400,
    cursor: 'pointer',
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  },

  textContent2: {
    fontFamily: 'Onest',
    fontSize: '13px',
    fontWeight: 400,
    cursor: 'pointer',
    textDecoration: 'none',
    '@media (max-width : 768px)': {
      fontSize: '11px',
    },
  },
  copyRights: {
    width: '90%',
    color: '#8E8E8E',
    fontFamily: 'Onest',
    fontSize: '12px',
    fontWeight: 400,
    textDecoration: 'none',
    marginBottom: '30px !important',
  },
  rightSec: {
    width: '70%',
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    justifyContent: 'space-between',
    alignItems: 'end',
    '@media (max-width : 768px)': {
      alignItems: 'start',
      width: '100%',
    },
  },
  rigthLogoContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'end',
    alignItems: 'center',
    gap: '20px',
    marginBottom: '10px',
    '@media (max-width : 768px)': {
      justifyContent: 'start',
      gap: '5px',
    },
  },
  logo1: {
    width: '120px',
    height: '70px',
    marginTop: '10px',
    '@media (max-width: 768px)': {
      width: '80px',
    },
  },
  logo2: {
    width: '100px',
    height: '75px',
    marginTop: '6px',
    '@media (max-width: 768px)': {
      width: '80px',
      marginLeft: '6px',
    },
  },
  logo3: {
    width: '120px',
    height: '75px',
    marginTop: '6px',
    '@media (max-width: 768px)': {
      width: '100px',
      marginLeft: '6px',
    },
  },
  logoContainer: {
    display: 'flex',
    flexDirection: 'column',
    color: '#656565',
    fontSize: '14px',
  },
  rightTextContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'end',
    alignItems: 'center',
    gap: '25px',
    '@media (max-width: 768px)': {
      flexDirection: 'column',
      gap: '15px',
    },
  },
  line: {
    height: '60px',
    width: '1px',
    borderLeft: '1px solid #B7B3B3',
    marginTop: '25px',
  },
  rightBottomLogo: {
    display: 'flex',
    gap: '5px',
    alignItems: 'center',
  },
}));
